import React from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import styled from 'styled-components';

import ListItem from 'app/components/BookElements/ListItem';

import LayoutEngine from 'app/api/layoutEngine';
const layoutEngine = new LayoutEngine({
  listItem: ListItem,
});

function compileLayoutData(path, content, index) {
  let data;
  if (_.isString(content) || _.isArray(content)) {
    data = { type: 'listItem', path: [...path, index] };
  } else {
    data = {
      type: _.keys(content)[0].split(' ')[0],
      path: [...path, index, _.keys(content)[0]],
    };
  }
  return data;
}

const Container = styled.div`
  margin-left: ${props => `${(props.level - 1) * 30}px`};
`;

class List extends React.Component {
  render() {
    let { path, content } = this.props;
    const hasLevel = content[0].level;
    let level = hasLevel ? content.shift().level : 1;
    return (
      <Container level={level} aria-label="list">
        {_.map(content, (content, index) =>
          layoutEngine.render(compileLayoutData(path, content, index))
        )}
      </Container>
    );
  }
}

List.propTypes = {
  /**
   * content path
   */
  path: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  /**
   * book elements array
   */
  content: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.object])
      ),
    ])
  ),
};
List.defaultProps = {
  content: [],
};

const Component = inject('AppState')(observer(List));
Component.displayName = 'List';
export const ListComponent = List;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/List.js